import {Component, OnInit} from '@angular/core';
import {SaleStat} from '../../data/sale-stat';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ProjectService} from '../../../project-misc/data/project/project.service';
import {ReportsService} from '../../data/reports.service';
import {ProjectWindowComponent} from '../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {ProjectInfoComponent} from '../../../../../../../mobile/src/app/modules/project/view/project-info/project-info.component';
import {trackEntityById} from 'projects/core/src/public-api';
import {ReportStatColumnCounter, ReportStatLine} from '../../data/report-stats-page';
import {KanbanBoardService} from '../../../../../../../desktop/src/app/modules/kanban-board/data/kanban-board.service';
import {KanbanColumn} from '../../../../../../../desktop/src/app/modules/kanban-board/data/kanban-column';
import {UserService} from '../../../../../../../core/src/lib/login/data/user.service';
import {User} from '../../../../../../../core/src/lib/login/data/user';
import {ProjectStatus} from '../../../project-misc/data/project/statuses/project-status';
import {forkJoin} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-project-stat-reports',
  templateUrl: './project-stat-reports.component.html',
  styleUrls: ['./project-stat-reports.component.scss']
})
export class ProjectStatReportsComponent implements OnInit {
  projReports: ReportStatLine[] = [];
  copyList: ReportStatLine[] = [];

  counters: ReportStatColumnCounter[]

  sortMap = new Map();
  lastSortLabel: string;

  filtersLoading: boolean;
  contentLoading: boolean;

  trackEntityById = trackEntityById;

  userId: number;
  userName: string;

  startDate: string;
  finishDate: string;

  totalInfo: SaleStat

  columns: KanbanColumn[];
  selectedColumns: number[] = [];
  columnsMap = new Map<number, number>()

  users: User[];
  selectedUsers: number[] = [];
  usersMap = new Map<number, number>()

  statuses: ProjectStatus[]
  selectedStatuses: number[] = [];
  statusesMap = new Map<number, number>()

  installStatuses: ProjectStatus[]
  selectedInstallStatuses: number[] = [];
  installStatusesMap = new Map<number, number>()

  loadingCount = 0;

  filterObj = {
    managers: [],
    columns: [],
    paymentStatuses: [],
    installationPaymentStatuses: []
  };

  constructor(
    protected kanbanBoardService: KanbanBoardService,
    protected userService: UserService,
    protected projectService: ProjectService,
    protected dialog: MatDialog,
    protected deviceDetectorService: DeviceDetectorService,
    protected reportsService: ReportsService
  ) {
  }


  ngOnInit(): void {
    this.filtersLoading = true;

    forkJoin([
      this.kanbanBoardService.getColumnNames(),
      this.userService.getProjectManagers(),
      this.projectService.getPaymentStatuses(),
      this.projectService.getInstallationPaymentStatuses()]).subscribe(res => {
      this.columns = res[0]
      this.users = res[1]
      this.statuses = res[2]
      this.installStatuses = res[3]

      this.projReports = [];
      this.copyList = [];
      this.filtersLoading = false

      this.nullifyMap();

      // this.sortMap.set('list', 1);

      this.fillMaps();
    })
  }

  getReports() {
    this.filterObj = {
      columns: this.selectedColumns,
      managers: this.selectedUsers,
      paymentStatuses: this.selectedStatuses,
      installationPaymentStatuses: this.selectedInstallStatuses
    }

    this.contentLoading = true;

    this.reportsService.getProjectReports(this.startDate, this.finishDate, 0, 100, this.filterObj).subscribe(pageContent => {
      this.projReports = pageContent.projects.content

      this.copyList = [...this.projReports];
      this.counters = pageContent.counters
      this.totalInfo = pageContent.salesStats

      this.contentLoading = false;
    }, () => {
      this.contentLoading = false;
    })
  }

  nullifyMap() {
    this.sortMap.set('created', 0);
    this.sortMap.set('list', 0);
    this.sortMap.set('manager', 0);
    this.sortMap.set('paymentStatus', 0);
    this.sortMap.set('installPaymentStatus', 0);
    this.sortMap.set('project', 0);
  }

  fillMaps() {
    this.users.forEach((user, index) => {
      this.usersMap.set(user.id, index)
    })
    this.columns.forEach((col, index) => {
      this.columnsMap.set(col.id, index)
    })
    this.statuses.forEach((status, index) => {
      this.statusesMap.set(status.id, index)
    })
    this.installStatuses.forEach((status, index) => {
      this.installStatusesMap.set(status.id, index)
    })
  }

  updateFilter(filter) {
    this.startDate = filter.startDate;
    this.finishDate = filter.finishDate

    this.selectedUsers = filter.users
    this.selectedColumns = filter.columns
    this.selectedStatuses = filter.statuses
    this.selectedInstallStatuses = filter.installStatuses

    this.getReports()
  }

  countMap(param: string) {
    let num = this.sortMap.get(param);
    if (num === 1) {
      num++;
    } else if (num === 0) {
      this.nullifyMap();
      num++;
    } else if (num === 2) {
      num = 0;
    }

    this.sortMap.set(param, num);
  }

  sortByLabel(param: string) {
    if (!this.contentLoading) {
      this.lastSortLabel = param;

      this.countMap(param);
      let numm = 1;
      if (this.sortMap.get(param) === 2) numm = -1;
      if (this.sortMap.get(param) === 0) {
        this.projReports = [...this.copyList]
        return
      }

      this.projReports.sort((a, b) => {
        if (param === 'created') {
          return (b.created.getTime() - a.created.getTime()) * numm;
        }
        if (param === 'manager' || param === 'project') {
          let aString = a[param].name
          let bString = b[param].name

          if (a[param].name === '') {
            aString = 'z'
          }
          if (b[param].name === '') {
            bString = 'z'
          }

          if (aString < bString) {
            return -1 * numm;
          }
          if (aString > bString) {
            return numm;
          }
          return 0;
        }
        if (param === 'list' || param === 'paymentStatus' || param === 'installPaymentStatus') {
          if (param === 'list') {
            const aIndex = this.columnsMap.get(a.list.id);
            const bIndex = this.columnsMap.get(b.list.id);

            return (aIndex - bIndex) * numm
          }
          if (param === 'paymentStatus') {
            const aIndex = this.statusesMap.get(a.paymentStatus.id);
            const bIndex = this.statusesMap.get(b.paymentStatus.id);

            return (aIndex - bIndex) * numm
          }
          if (param === 'installPaymentStatus') {
            const aIndex = this.installStatusesMap.get(a.installationPaymentStatus.id);
            const bIndex = this.installStatusesMap.get(b.installationPaymentStatus.id);

            return (aIndex - bIndex) * numm
          }
        }

        return (b[param] - a[param]) * numm
      })
    }
  }

  openProject(projectId: number) {

    let projectWindow = ProjectWindowComponent as any;

    let panelClass = 'project-window-dialog'

    if (this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet()) {
      projectWindow = ProjectInfoComponent
      panelClass = 'project-info-dialog'
    }

    const dialogRef = this.dialog.open(projectWindow, {
      data: {
        projectNumber: projectId
      },
      panelClass
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

}
